import React, { useContext, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material';
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal';
import Condicional from '../../../Layout/Condicional';
import CloseIcon from '@mui/icons-material/Close';

import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable';
import { useNavigate } from 'react-router-dom';

import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev';
import { FatorRHConteudoPermitidoInterface, FatorRHCorrespondenciaDetalheInterface, FatorRHCorrespondenciaInterface } from '../../../ImportBackend/Interfaces/FatorRHInterfaces';
import BackEndAPI from '../../../Services/BackEndAPI';
import { MensagemTipo } from '../../../GlobalStates/MensagemState';
import DataTableCrud from '../../../DevComponents/DataTableCrud';
import FatorRHClientesDeParaInput from './FatorRHClientesDeParaInput';
import ClsUtils from 'zlib-utils';
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces';
import ComboBox from '../../../DevComponents/ComboBox';
import { GrupoFatorRHInterface, GrupoFatorRHTypes } from '../../../ImportBackend/types/ConstantesDataTypes';

export interface CrudDetalhePropsInterface {
  valorUnico: boolean
  conteudoPermitido: Array<FatorRHConteudoPermitidoInterface>
}

export default function FatorRHClientesDePara () {

  const navigate = useNavigate()

  const [editarDetalhe, setEditarDetalhe] = useState<boolean>( false )
  const [selecioarFatorRHCorrespondencia, setSelecioarFatorRHCorrespondencia] = useState<boolean>( true )

  const clsApi: BackEndAPI = new BackEndAPI()
  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto
  const { loginState } = contexto

  const [erros] = useState( {} )

  const [rsDetalhe, setRsDetalhe] = useState<Array<FatorRHCorrespondenciaDetalheInterface>>( [] )
  const [rsFatorRHCorrespondencia, setRsFatorRHCorrespondencia] = useState<FatorRHCorrespondenciaInterface>()
  const [rsPesquisaCorrespondencia, setRsPesquisaCorrespondencia] = useState<Array<FatorRHCorrespondenciaInterface>>( [] )

  const resetDados = {
    grupo: ''
  }

  const [dados, setDados] = useState<typeof resetDados>( resetDados )
  const clsUtils: ClsUtils = new ClsUtils()

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'ERP',
      campo: 'conteudoBancoDados',
      alinhamento: 'left'
    },
    {
      cabecalho: 'FatorRH',
      campo: 'conteudoFatorRH',
      alinhamento: 'left',
      format: ( v ) => rsFatorRHCorrespondencia?.conteudoPermitido.find( cp => cp.chave === v )?.descricaoConteudo || v
    }
  ]

  const CabecalhoPesquisaCorrespondencia: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'descricao',
      cabecalho: 'Descrição',
      alinhamento: 'left'
    }
  ]

  const pesquisarCorrespondenciasDoGrupo = ( rsGrupoFatorRH: GrupoFatorRHInterface ) => {

    if ( rsGrupoFatorRH ) {

      const query = `
        getFatorRHCorrespondenciasPorGrupo(grupo: "${rsGrupoFatorRH.descricao}") {
          idFatorRHCorrespondencia
          grupo
          descricao
          campo
          valorUnico
          conteudoPermitido {
            descricaoConteudo
            chave
          }
        }
      `

      clsApi.query<Array<FatorRHCorrespondenciaInterface>>( query, 'getFatorRHCorrespondenciasPorGrupo', 'Pesquisando De Para...', contexto ).then( rs => {
        setRsPesquisaCorrespondencia( rs )
        setDados( { grupo: rsGrupoFatorRH.descricao } )
        setSelecioarFatorRHCorrespondencia( true )
        setEditarDetalhe( false )

      } ).catch( ( e ) => {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro ao Consultar De / Para!',
          exibir: true,
          mensagem: e.message,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      } )

    } else {
      setRsPesquisaCorrespondencia( [] )
      setDados( resetDados )
      setSelecioarFatorRHCorrespondencia( false )
      setEditarDetalhe( false )
    }



  }

  const pesquisarDetalheCorrespondencia = ( rsCorrespondencia: FatorRHCorrespondenciaInterface ) => {

    if ( rsCorrespondencia && rsCorrespondencia.idFatorRHCorrespondencia ) {

      setRsFatorRHCorrespondencia( rsCorrespondencia );

      const query = `
        getFatorRHCorrespondenciaDetalhe(idCliente: ${loginState.idClienteAtual}, idFatorRHCorrespondencia: ${rsCorrespondencia.idFatorRHCorrespondencia}) {
          idFatorRHCorrespondenciaDetalhe
          idFatorRHCorrespondencia
          conteudoBancoDados
          conteudoFatorRH
        }
      `

      clsApi.query<Array<FatorRHCorrespondenciaDetalheInterface>>( query, 'getFatorRHCorrespondenciaDetalhe', 'Pesquisando De Para...', contexto ).then( rs => {
        setRsDetalhe( rs )
        setEditarDetalhe( true )
        setSelecioarFatorRHCorrespondencia( false )

      } ).catch( ( e ) => {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro ao Consultar De / Para!',
          exibir: true,
          mensagem: e.message,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      } )

    } else {

      setRsDetalhe( [] )
      setEditarDetalhe( false )

    }

  }

  const onIncluirAlterarDetalhe = ( rsRegistro: FatorRHCorrespondenciaDetalheInterface ) => {

    const tmpRegistro: FatorRHCorrespondenciaDetalheInterface = {
      conteudoBancoDados: rsRegistro.conteudoBancoDados,
      conteudoFatorRH: rsRegistro.conteudoFatorRH,
      idFatorRHCorrespondencia: rsFatorRHCorrespondencia ? rsFatorRHCorrespondencia.idFatorRHCorrespondencia as number : 0,
      idCliente: loginState.idClienteAtual as number,
      idFatorRHCorrespondenciaDetalhe: rsRegistro.idFatorRHCorrespondenciaDetalhe || 0
    }

    const mutation = `
      updateFatorRHCorrespondenciaDetalhe(dados: ${clsUtils.ConverterEmGql( tmpRegistro )}) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'updateFatorRHCorrespondenciaDetalhe', 'Atualizando "De Para"...', contexto ).then( rs => {

      if ( !rs.ok ) {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro ao Atualizar De / Para!',
          exibir: true,
          mensagem: rs.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      } else {
        pesquisarDetalheCorrespondencia( rsFatorRHCorrespondencia as FatorRHCorrespondenciaInterface )
      }


    } ).catch( ( e ) => {

      setMensagemState( {
        ...mensagemState,
        titulo: 'Erro ao Atualizar De / Para!',
        exibir: true,
        mensagem: e.message,
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

    } )

  }

  const onExcluirDetalhe = ( rsRegistro: FatorRHCorrespondenciaDetalheInterface ) => {

    const mutation = `
      delFatorRHCorrespondenciaDetalhe(idFatorRHCorrespondenciaDetalhe: ${rsRegistro.idFatorRHCorrespondenciaDetalhe}) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'delFatorRHCorrespondenciaDetalhe', 'Atualizando "De Para"...', contexto ).then( rs => {

      if ( !rs.ok ) {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro ao Atualizar De / Para!',
          exibir: true,
          mensagem: rs.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      } else {
        pesquisarDetalheCorrespondencia( rsFatorRHCorrespondencia as FatorRHCorrespondenciaInterface )
      }


    } ).catch( ( e ) => {

      setMensagemState( {
        ...mensagemState,
        titulo: 'Erro ao Atualizar De / Para!',
        exibir: true,
        mensagem: e.message,
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

    } )

  }

  const onFatorRHCorrespondenciaSelecionada = ( rs: FatorRHCorrespondenciaInterface ) => {
    pesquisarDetalheCorrespondencia( rs )
  }

  const onCancelarEdicaoDetalhe = () => {
    setEditarDetalhe( false )
    setRsDetalhe( [] )
    setRsFatorRHCorrespondencia( undefined )
    setSelecioarFatorRHCorrespondencia( true )
  }

  const [currentPageOptions, setCurrentPageOptions] = useState<{ page: number; rowsPerPage: number }>( { page: 0, rowsPerPage: 10 } )

  const onChangeCurrentPageOptions = ( options: { page: number; rowsPerPage: number } ) => {
    setCurrentPageOptions( options )
  }

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>

          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Condicional condicao={!editarDetalhe}>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                <Typography component="h5" variant="h5" align="left">
                  Cadastro "De - Para"
                  <Typography variant="body2" gutterBottom>
                    Mapeamento de dados entre o ERP e o FatorRH
                  </Typography>
                </Typography>

                <IconButton onClick={() => navigate( '/' )}>
                  <CloseIcon />
                </IconButton>
              </Grid>

              <Grid item xs={12}>

                <ComboBox
                  dados={dados}
                  field='grupo'
                  label='Grupo'
                  erros={erros}
                  campoDescricao='descricao'
                  campoID='descricao'
                  opcoes={GrupoFatorRHTypes}
                  onChange={( v: GrupoFatorRHInterface ) => pesquisarCorrespondenciasDoGrupo( v )}
                />

                {/*
              <PesquisarTabela<FatorRHCorrespondenciaInterface>
                onChange={( v ) => pesquisarDetalheCorrespondencia( v )}
                field='idFatorRHCorrespondencia'
                fieldSet='idFatorRHCorrespondencia'
                label='De / Para'
                dados={dados}
                campoQueryPesquisaID='idFatorRHCorrespondencia'
                campoQueryPesquisa='pesquisa'
                camposRetornoQueryPesquisa='{idFatorRHCorrespondencia, descricao, conteudoPermitido {chave descricaoConteudo}}'
                campoLabelQueryPesquisa='descricao'
                nomeQueryPesquisa='getFatorRHCorrespondencias'
                nomeQueryPesquisaID='getFatorRHCorrespondenciaPorId'
                mensagemPesquisa='Procurando De / Para...'
                erros={erros}
                pesquisarTudoAoIniciar
                valorAtribuirLimpar={0}
              />
              */}

              </Grid>

              <Condicional condicao={selecioarFatorRHCorrespondencia}>
                <Grid item xs={12} sx={{ mt: 3 }}>
                  <DataTable<FatorRHCorrespondenciaInterface>
                    dados={rsPesquisaCorrespondencia}
                    onChangeCurrentPageOptions={( rs ) => onChangeCurrentPageOptions( rs )}
                    currentPageOptions={currentPageOptions}
                    cabecalho={CabecalhoPesquisaCorrespondencia} acoes={
                      [
                        { icone: 'edit_note', toolTip: 'De / Para', onAcionador: ( rs ) => onFatorRHCorrespondenciaSelecionada( rs ) },
                        // { icone: 'create', toolTip: 'Alterar', onAcionador: clsCrud.btEditar }
                      ]
                    } />
                </Grid>
              </Condicional>

            </Condicional>

            <Condicional condicao={editarDetalhe}>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <Typography component="h5" variant="h5" align="left">
                  {rsFatorRHCorrespondencia?.grupo}
                </Typography>
              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 3, mb: 3 }}>

                <Typography component="h5" variant="h5" align="left">
                  {rsFatorRHCorrespondencia?.descricao}
                  <Typography variant="body2" gutterBottom>
                    Edição dos mapeamentos "De - Para"
                  </Typography>
                </Typography>

                <IconButton onClick={() => onCancelarEdicaoDetalhe()}>
                  <CloseIcon />
                </IconButton>

              </Grid>

              <Grid item xs={12}>
                <DataTableCrud<FatorRHCorrespondenciaDetalheInterface, CrudDetalhePropsInterface>
                  tituloCrud='De - Para | ERP - FatorRH'
                  dados={[...rsDetalhe]}
                  cabecalho={Cabecalho}
                  ComponenteInputCrud={FatorRHClientesDeParaInput as any}
                  dadosIniciaisRegistro={{
                    conteudoBancoDados: rsFatorRHCorrespondencia?.valorUnico ? 'FIXO' : '',
                    conteudoFatorRH: '',
                    idCliente: loginState.idClienteAtual as number,
                    idFatorRHCorrespondencia: rsFatorRHCorrespondencia ? rsFatorRHCorrespondencia.idFatorRHCorrespondencia as number : 0,
                    idFatorRHCorrespondenciaDetalhe: 0
                  }}
                  onAlterar={( v ) => onIncluirAlterarDetalhe( v )}
                  onExcluir={( v ) => onExcluirDetalhe( v )}
                  onIncluir={( v ) => onIncluirAlterarDetalhe( v )}
                  props={{
                    valorUnico: rsFatorRHCorrespondencia?.valorUnico || false,
                    conteudoPermitido: rsFatorRHCorrespondencia?.conteudoPermitido || []
                  }}
                  permitirInclusao={rsFatorRHCorrespondencia?.valorUnico && rsDetalhe.length === 0 || !rsFatorRHCorrespondencia?.valorUnico}
                  rowsPerPageOptions={[5, 3, 7]}
                />
              </Grid>
            </Condicional>
          </Grid>

        </Paper >

      </Container >

      <ExibirJSONDev oque={['dados', dados, 'rsFatorRHCorrespondencia', rsFatorRHCorrespondencia, 'rsDetalhe', rsDetalhe]} />
    </>
  )
}